import { defineStore } from "pinia";
import Snackbar, { SnackBarColors } from "../utils/Snackbar";


interface SnackbarState {
    message: string | null,
    color: string | null,
    show: boolean,
    snacks: Snackbar[]
}




export const useSnackbarStore = defineStore('snackbar', {
    state: (): SnackbarState => ({
        message: null,
        color: null,
        show: false,
        snacks: []
    }),

    getters: {
    },

    actions: {

        addSnackbar(message: string, color: SnackBarColors = 'default', duration?: number) {
            const snack = new Snackbar(message, color, duration)
            this.snacks.push(snack)
        },

        // Remove the first snack in the array
        popSnackbar() {
            if (this.snacks.length > 0) {
                this.snacks.shift()
            }
        },

        removeSnackbar(snackId: string) {
            const index = this.snacks.findIndex((snack) => snack.id === snackId)
            if (index > -1) {
                this.snacks.splice(index, 1)
            }
        }
    }
})